import React from 'react';

// Bootstrap components
import { Button, OverlayTrigger } from 'react-bootstrap';

import styles from './info.module.scss';

// Font Awesome (free) icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

// Tooltips
const renderTooltipFactory = infoMessage => {
    // Returns a function displaying infoMessage as a tooltip
    return ({ placement, scheduleUpdate, arrowProps, outOfBoundaries, show, ...props }) => (
        <div
            {...props}
            style={{
                backgroundColor: 'black',
                padding: '2px 10px',
                marginTop: '1.5rem',
                color: 'white',
                borderRadius: 3,
                ...props.style,
            }}
        >
            {infoMessage}
        </div>
    );
}
// Info provides mouse-over info above a circle info icon
const Info = (props) => (
    <span
        {...props} 
        className={"input-group-text " + styles.infoTooltip}    
    >
        <OverlayTrigger
            placement="left-start"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltipFactory(props.children) /* render props.children as tooltip */}
        >
            <Button style={{
                background: "none",
            }}> {/* Inline style can override Bootstrap default */}
                <FontAwesomeIcon icon={faInfoCircle} />
            </Button>
        </OverlayTrigger>
    </span>
);

export default Info